module.exports = __webpack_public_path__ + "static/media/code.6fae2207.png";